import { render, staticRenderFns } from "./employerDetails.vue?vue&type=template&id=e72dfa88&scoped=true"
import script from "./employerDetails.vue?vue&type=script&lang=js"
export * from "./employerDetails.vue?vue&type=script&lang=js"
import style0 from "./employerDetails.vue?vue&type=style&index=0&id=e72dfa88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72dfa88",
  null
  
)

export default component.exports